import { IconProps } from '../types';

function FolderRulersSolidIcon({ className, id }: IconProps) {
  return (
    <svg
      id={id}
      className={className || 'h-5 w-5'}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M16 6h-5L9 4H4c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-.5 8h-11v-3h1v1h1v-1h1v2h1v-2h1v1h1v-1h1v2h1v-2h1v1h1v-1h1v3z" />
    </svg>
  );
}

export default FolderRulersSolidIcon;
